// src/api/groupPostAPI.js
import apiClient from '../../../redux/authentication/utils/core/axios';

const GroupPostAPI = {
  getGroupPosts: async ({ groupId, skip = 0, limit = 10 }) => {
    const res = await apiClient.get('/group_posts', { params: { group_id: groupId, skip, limit } });
    if (res.status !== 200) throw new Error('Failed to fetch group posts');
    return res.data; // { posts, has_more }
  },

  createGroupPost: async ({ groupId, title, content, evidence = [], disclosesPosition = false }) => {
    const res = await apiClient.post('/group_posts/', {
      group_id: groupId,
      title,
      content,
      evidence, // PostEvidenceCreate[]
      discloses_position: disclosesPosition, // MAR Art 20
    });
    if (res.status !== 201) throw new Error('Failed to create group post');
    return res.data; // GroupPostDisplay
  },

  updateGroupPost: async (postId, payload) => {
    const res = await apiClient.put(`/group_posts/${postId}`, payload);
    if (res.status !== 200) throw new Error('Failed to update group post');
    return res.data; // GroupPostDisplay
  },

  deleteGroupPost: async (postId) => {
    const res = await apiClient.delete(`/group_posts/${postId}`);
    if (res.status !== 204) throw new Error('Failed to delete group post');
    return postId;
  },

  // ── Reactions ──────────────────────────────────────────────────────────────

  likePost: async (postId) => {
    const res = await apiClient.post(`/group_posts/${postId}/like`);
    if (res.status !== 200) throw new Error('Failed to like post');
    return res.data; // { post_id, likes, is_liked }
  },

  unlikePost: async (postId) => {
    const res = await apiClient.delete(`/group_posts/${postId}/like`);
    if (res.status !== 200) throw new Error('Failed to unlike post');
    return res.data; // { post_id, likes, is_liked }
  },

  bullPost: async (postId) => {
    const res = await apiClient.post(`/group_posts/${postId}/bull`);
    if (res.status !== 200) throw new Error('Failed to bull post');
    return res.data; // { post_id, i_bulled, i_beared, bull_count, bear_count }
  },

  unbullPost: async (postId) => {
    const res = await apiClient.delete(`/group_posts/${postId}/bull`);
    if (res.status !== 200) throw new Error('Failed to unbull post');
    return res.data;
  },

  bearPost: async (postId) => {
    const res = await apiClient.post(`/group_posts/${postId}/bear`);
    if (res.status !== 200) throw new Error('Failed to bear post');
    return res.data; // { post_id, i_beared, i_bulled, bull_count, bear_count }
  },

  unbearPost: async (postId) => {
    const res = await apiClient.delete(`/group_posts/${postId}/bear`);
    if (res.status !== 200) throw new Error('Failed to unbear post');
    return res.data;
  },

  // ── Comments ───────────────────────────────────────────────────────────────

  createComment: async ({ postId, content, parentCommentId = null }) => {
    const res = await apiClient.post('/group_post_comments/', {
      post_id: postId,
      content,
      parent_comment_id: parentCommentId,
    });
    if (res.status !== 201) throw new Error('Failed to create comment');
    return res.data; // GroupCommentDisplay
  },

  updateComment: async (commentId, content) => {
    const res = await apiClient.put(`/group_post_comments/${commentId}`, { content });
    if (res.status !== 200) throw new Error('Failed to update comment');
    return res.data; // GroupCommentDisplay
  },

  deleteComment: async (commentId) => {
    const res = await apiClient.delete(`/group_post_comments/${commentId}`);
    if (res.status !== 204) throw new Error('Failed to delete comment');
    return commentId;
  },

  likeComment: async (commentId) => {
    const res = await apiClient.post(`/group_post_comments/${commentId}/like`);
    if (res.status !== 201) throw new Error('Failed to like comment');
    return res.data; // { like_id, user_id, comment_id }
  },

  unlikeComment: async (commentId) => {
    const res = await apiClient.delete(`/group_post_comments/${commentId}/like`);
    if (res.status !== 200) throw new Error('Failed to unlike comment');
    return res.data;
  },
};

export default GroupPostAPI;